import { useState } from "react";
import * as Scrivito from "scrivito";
import LinkTitle from "../utils/LinkTitle";
import getLanguage from "../utils/getLanguage";

function Disturber() {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const obj = Scrivito.currentPage();
  const lang = getLanguage(obj);
  const validFrom = obj?.get("disturberValidFrom");
  const validUntil = obj?.get("disturberValidUntil");
  const now = new Date();

  if (validFrom && now < validFrom) {
    if (Scrivito.isInPlaceEditingActive()) {
      return (
        <div className="alert alert-info">
          The disturber will be visible from {validFrom.toLocaleString(lang)}.
        </div>
      );
    }
    return null;
  }

  if (validUntil && now > validUntil) {
    if (Scrivito.isInPlaceEditingActive()) {
      return (
        <div className="alert alert-info">
          The disturber was visible until {validUntil.toLocaleString(lang)}.
        </div>
      );
    }
    return null;
  }

  if (
    obj === null ||
    (obj.get("disturberText") || "").replace(/(<([^>]+)>)/gi, "") === ""
  ) {
    return null;
  }

  const links = obj.get("disturberLink");

  if (!visible) {
    return null;
  }

  return (
    <div className="mb-0 rounded-0 disturber p-3 bg-yellow">
      <button
        className="close"
        onClick={onDismiss}
        title={lang === "de" ? "Anzeige schließen" : "Close disturber"}
      >
        <i className="las la-times" />
      </button>
      <div className="disturber-content container">
        <Scrivito.ContentTag
          tag="div"
          content={obj}
          attribute="disturberText"
          className="disturber-content-text"
        />
        {links && (
          <div className="disturber-links">
            {links.map((link, index) => (
              <Scrivito.LinkTag to={link} key={index}>
                <i className="las la-link me-1" />
                <LinkTitle link={link} />
              </Scrivito.LinkTag>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Scrivito.connect(Disturber);
